module.exports = __webpack_public_path__ + "img/marker-map.0bab8d71.svg";